import { render, staticRenderFns } from "./AddEducationDetails.vue?vue&type=template&id=7ab17b3f&scoped=true"
import script from "./AddEducationDetails.vue?vue&type=script&lang=js"
export * from "./AddEducationDetails.vue?vue&type=script&lang=js"
import style0 from "./AddEducationDetails.vue?vue&type=style&index=0&id=7ab17b3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab17b3f",
  null
  
)

export default component.exports